import React, { useEffect } from "react";

import "./App.css";
import "./styles/navbar.css";

import { ToastContainer } from "react-toastify";

import { Provider } from "react-redux";

import store from "./store";

import Routes from "./Routes";

import AuthProvider from "./components/ContextApi/AuthProvider";

import { connectSocket } from "./utils/socket";
import PlatformAuthProvider from "./components/ContextApi/PlatformAuthProvider";

const App = () => {
  /*
    |--------------------------------------------------------------------------
    | SOCKET
    |--------------------------------------------------------------------------
    */

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      connectSocket(token);
    }
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider>
        <PlatformAuthProvider>
          <Routes />

          <ToastContainer
            position="top-right"
            autoClose={3000}
            newestOnTop
            closeOnClick
            pauseOnHover
          />
        </PlatformAuthProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
